import { post } from './http.js'

// 登录认证
export const sendAuthCode = (data) => post('/unicom/cluster/login/sendMobileCode', data)
export const smsAuthCode = (data) => post('/unicom/cluster/login/loginByMobileCode', data)
